var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGrid = function SvgGrid(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.5 10.5h-4v4h4zm-4-1.5h4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-4A1.5 1.5 0 0 1 9 14.5v-4A1.5 1.5 0 0 1 10.5 9M5.5 1.5h-4v4h4zm9 0h-4v4h4zm-9 9h-4v4h4zM5.5 0h-4A1.5 1.5 0 0 0 0 1.5v4A1.5 1.5 0 0 0 1.5 7h4A1.5 1.5 0 0 0 7 5.5v-4A1.5 1.5 0 0 0 5.5 0m9 0h-4A1.5 1.5 0 0 0 9 1.5v4A1.5 1.5 0 0 0 10.5 7h4A1.5 1.5 0 0 0 16 5.5v-4A1.5 1.5 0 0 0 14.5 0m-13 9h4A1.5 1.5 0 0 1 7 10.5v4A1.5 1.5 0 0 1 5.5 16h-4A1.5 1.5 0 0 1 0 14.5v-4A1.5 1.5 0 0 1 1.5 9",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrid);
export default ForwardRef;